export default "__VITE_ASSET__DknjuRSP__"